/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AntiDdosConfigResponse,
  OneClickIntentRequest,
  OneClickIntentStatus,
} from '../models/index';

export interface GetIntentStatusRequest {
    intentHash: string;
}

export interface SubmitIntentRequest {
    blockchain: SubmitIntentBlockchainEnum;
    oneClickIntentRequest: OneClickIntentRequest;
}

/**
 * 
 */
export class TradingV2ControllerApi extends runtime.BaseAPI {

    /**
     */
    async getAntiDdosConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AntiDdosConfigResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/trading/anti-ddos-config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAntiDdosConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AntiDdosConfigResponse>> {
        const response = await this.getAntiDdosConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getIntentStatusRaw(requestParameters: GetIntentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OneClickIntentStatus>> {
        if (requestParameters['intentHash'] == null) {
            throw new runtime.RequiredError(
                'intentHash',
                'Required parameter "intentHash" was null or undefined when calling getIntentStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/trading/{intent_hash}/status`.replace(`{${"intent_hash"}}`, encodeURIComponent(String(requestParameters['intentHash']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getIntentStatus(requestParameters: GetIntentStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OneClickIntentStatus> {
        const response = await this.getIntentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPoolSizeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/trading/poolSize`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getPoolSize(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getPoolSizeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async submitIntentRaw(requestParameters: SubmitIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['blockchain'] == null) {
            throw new runtime.RequiredError(
                'blockchain',
                'Required parameter "blockchain" was null or undefined when calling submitIntent().'
            );
        }

        if (requestParameters['oneClickIntentRequest'] == null) {
            throw new runtime.RequiredError(
                'oneClickIntentRequest',
                'Required parameter "oneClickIntentRequest" was null or undefined when calling submitIntent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockchain'] != null) {
            queryParameters['blockchain'] = requestParameters['blockchain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v2/trading/submit-intent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['oneClickIntentRequest'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async submitIntent(requestParameters: SubmitIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.submitIntentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum SubmitIntentBlockchainEnum {
    Monad = 'MONAD'
}
